import { ECode } from "~/_enums/ECode";
import { TApiConfig } from "~/_libs/fetch/fetchConfig";
import { fetchPostJson } from "~/_libs/fetch/fetchPostJson";

type TPostCommonCreateShortAuthTokenOutput = {
  code: ECode;
  data: {
    token: string;
  };
};

export const postCommonCreateShortAuthToken = (
  config: TApiConfig,
): Promise<TPostCommonCreateShortAuthTokenOutput> =>
  fetchPostJson("/v5draft/common-create-short-auth-token", {}, config);
